export default {
	'search-item-id-or-name': 'Öğe isimi ya da numarası ara',
	'show-main-item': 'Ana öğe Göster',
	'items-with-quantities-only': 'Sadece miktarları olan ürünler',
	'store-items': 'Depo',
	'inventory-matching': 'Envanter eşleşmesi',
	'final-value': 'Nihai değer'
}